module.exports = __webpack_public_path__ + "img/tutorialDescarga.f347c42c.png";